import { render, staticRenderFns } from "./ChatInputBar.vue?vue&type=template&id=412d1e85&scoped=true"
import script from "./ChatInputBar.vue?vue&type=script&lang=js"
export * from "./ChatInputBar.vue?vue&type=script&lang=js"
import style0 from "./ChatInputBar.vue?vue&type=style&index=0&id=412d1e85&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "412d1e85",
  null
  
)

export default component.exports